import { getMenuCommodities } from "@/_core/data/api_calls/menu/getMenuCommodities";
import { getMenuCurrencies } from "@/_core/data/api_calls/menu/getMenuCurrencies";

/**
 * Fetches the menu options for a given asset type (commodities or currencies).
 *
 * @param {object} ctx - Context variables (state management for the component).
 * @param {string} asset - The type of asset ("currency" or "commodity").
 * @returns {Promise} - Returns a promise resolving to the fetched menu data.
 */
export function getMenu(ctx, asset) {
  // Set loading state
  ctx.showLoading = true;

  // Determine the correct API call based on asset type
  switch (asset) {
    case "currency":
      return getMenuCurrencies(ctx);
    case "commodity":
      return getMenuCommodities(ctx);
    default:
      console.warn(`Invalid asset type: ${asset}`);
      ctx.showLoading = false;
      return Promise.reject(new Error("Invalid asset type"));
  }
}
